import { render, staticRenderFns } from "./create-log.vue?vue&type=template&id=bcf0cdb4&"
import script from "./create-log.vue?vue&type=script&lang=ts&"
export * from "./create-log.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports